import React, { useState, useEffect, useCallback } from "react";
import { getLocalStorageInfo, getGlobalCookie, authorizeAutoLogin, setGlobalCookie } from "../utils";
import { DesktopHeader, MobileHeader, DesktopSideNav, MntSideNav, PageLoader } from "../shared_elements";
import { connect } from "react-redux";
import config from "../config";
import * as actions from "../shared_elements/actions";
import { getAllAssetListAc } from "../shared_elements/actionCreators";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import { Hidden } from "@material-ui/core";
import { SidebarContext } from "../contexts/SidebarContext";

window.addEventListener("visibilitychange", checkLogin);

function checkLogin() {
	if (document.visibilityState || document.hasFocus) {
		const userInfo = JSON.parse(localStorage.getItem("userInfo"));
		const location = window.location.href;
		const lessorAccess = JSON.parse(getGlobalCookie("lessorAccess"));
		if (!location.includes("login") && !location.includes("select-lessor")) {
			setGlobalCookie("redirectURIRecords", location, 3);
		}
		if (lessorAccess == null) {
			localStorage.clear();
			if (!location.includes("login") && !location.includes("shared-data") && !location.includes("records/preview")) {
				window.location.reload();
			}
		} else if (config.api.networkInterface.includes(lessorAccess.environment)) {
			if (!getLocalStorageInfo()) {
				authorizeAutoLogin({ lessor_id: lessorAccess.id });
			} else if (!location.includes("select-lessor")) {
				if (lessorAccess.id !== userInfo.defaultLessor.id || getLocalStorageInfo().access !== lessorAccess.access) {
					authorizeAutoLogin({ lessor_id: lessorAccess.id });
				}
			}
		}
	}
}

const LAYOUT_MARGINS = {
	0: "50px 0 0 0",
	1: "60px 0 0 75px",
	2: "70px 0 0 300px",
	3: "20px 0 0 77px",
};

// DesktopSideNav is fixed at 77px. Secondary sidebar (secondary-sidenav-bg) is 200px wide.
const DESKTOP_SIDEBAR_OPEN_ML = 250;  // 77 + 200
const DESKTOP_SIDEBAR_CLOSED_ML = 120; // 77 + ~50 (toggle button area)
const MOBILE_SIDEBAR_OPEN_ML = 185;   // 0 + 180px (mobile sidenav) + 5px buffer
const MOBILE_SIDEBAR_CLOSED_ML = 50;  // just the toggle button

export default function PageLayout(HocComponent, extraProps = {}) {
	const layoutMargin = LAYOUT_MARGINS[extraProps.layoutPhase] ?? "0";

	function Layout(props) {
		const [sidebarOpen, setSidebarOpen] = useState(true);

		useEffect(() => {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			const lessorAccess = JSON.parse(getGlobalCookie("lessorAccess"));
			if (config.api.networkInterface.includes(lessorAccess.environment)) {
				if (!getLocalStorageInfo()) {
					authorizeAutoLogin({ lessor_id: lessorAccess.id });
				} else if (lessorAccess.id !== userInfo.defaultLessor.id) {
					authorizeAutoLogin({ lessor_id: lessorAccess.id });
				}
			}
		}, []);

		const toggleSidebar = useCallback(() => setSidebarOpen((prev) => !prev), []);

		if (!getLocalStorageInfo()) return <PageLoader />;

		const secondarySidebar = extraProps.layoutPhase === 2 && (
			<div className="secondary-sidenav-bg">
				<div className="sidebar-icon">
					<button className="menu-button btn btn-primary" onClick={toggleSidebar}>
						{sidebarOpen ? <CloseIcon /> : <MenuIcon />}
					</button>
				</div>
				<div className={`secondary-sidenav pt-0 ${sidebarOpen ? "d-block" : "d-none"}`}>
					<MntSideNav />
				</div>
			</div>
		);

		return (
			<SidebarContext.Provider value={sidebarOpen}>
				<section>
					<Hidden only={["lg", "xl"]}>
						<MobileHeader />
					</Hidden>
					<Hidden only={["xs", "sm", "md"]}>
						<DesktopHeader />
						<DesktopSideNav />
					</Hidden>
					{/* Fixed secondary sidebar — position:fixed, rendered once for both breakpoints */}
					{secondarySidebar}
					{/* Desktop content */}
					<Hidden only={["xs", "sm", "md"]}>
						{extraProps.layoutPhase === 2 ? (
							<main style={{
								marginTop: "45px",
								marginLeft: sidebarOpen ? DESKTOP_SIDEBAR_OPEN_ML : DESKTOP_SIDEBAR_CLOSED_ML,
								// padding: "10px 20px 50px",
								 padding: "10px 20px 10px",
								background: "#fff",
								transition: "margin-left 0.15s ease",
							}}>
								<HocComponent {...props} />
							</main>
						) : (
							<main style={{ margin: layoutMargin, padding: "0px 20px 0px" }}>
								<HocComponent {...props} />
							</main>
						)}
					</Hidden>
					{/* Mobile content */}
					<Hidden only={["lg", "xl"]}>
						{extraProps.layoutPhase === 2 ? (
							<main style={{
								marginTop: "5px",
								marginLeft: sidebarOpen ? MOBILE_SIDEBAR_OPEN_ML : MOBILE_SIDEBAR_CLOSED_ML,
								padding: "10px",
								background: "#fff",
								transition: "margin-left 0.15s ease",
							}}>
								<HocComponent {...props} />
							</main>
						) : (
							<main style={{ marginTop: "5px", padding: "10px" }}>
								<HocComponent {...props} />
							</main>
						)}
					</Hidden>
				</section>
			</SidebarContext.Provider>
		);
	}

	const mapStateToProps = (state) => ({
		pltConstants: state.shareReducer.pltConstants,
		applicationSwitcher: state.shareReducer.applicationSwitcher,
		allAssets: state.shareReducer.allAssets,
	});

	const mapDispatchToProps = (dispatch) => ({
		getAllAssetListFn: () => dispatch(getAllAssetListAc()),
		toggleTheAppSwitcher: (flag) => dispatch({ type: actions.APPS_SWITCHER, payload: flag }),
	});

	return connect(mapStateToProps, mapDispatchToProps)(Layout);
}
